enum PaymentModalSteps {
  Recipients = 'recipients',
  Amount = 'amount',
  TermsAndConditions = 'termsAndConditions',
  PaymentMethod = 'paymentMethod',
  ConfirmPayment = 'confirmPayment',
  Enroll = 'enroll',
  Success = 'success',
}

export default PaymentModalSteps
